module.exports = __webpack_public_path__ + "img/big7-4.aaa0892f.jpg";